import { createSlice } from '@reduxjs/toolkit';
// Define the initial state using that type
const initialState = {
    selectedProject: null
};
export const slice = createSlice({
    name: 'commonData',
    initialState,
    reducers: {
        setSelectedProjectReducer: (state, action) => {
            state.selectedProject = action.payload;
        },
    },
});
export const { setSelectedProjectReducer } = slice.actions;
export default slice.reducer;
